export default __webpack_public_path__ + "static/media/ar_2009_image.1c8fa574.jpg";